type MetaAttr = 'name' | 'property';

export const upsertMetaTag = (attr: MetaAttr, key: string, content: string): void => {
    const selector = `meta[${attr}="${CSS.escape(key)}"]`;
    let element = document.head.querySelector<HTMLMetaElement>(selector);

    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, key);
        document.head.appendChild(element);
    }

    element.setAttribute('content', content);
};

export const upsertCanonicalLink = (href: string): void => {
    let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');

    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', 'canonical');
        document.head.appendChild(element);
    }

    element.setAttribute('href', href);
};

export const getDefaultShareImageUrl = (): string => {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const publicUrl = process.env.PUBLIC_URL || '';
    return `${origin}${publicUrl}/logo512.png`;
};

export const getPageUrl = (): string => {
    if (typeof window === 'undefined') {
        return '';
    }
    return `${window.location.origin}${window.location.pathname || '/'}`;
};
